import React from "react";
import { sameDay } from "../utils/calendarUtils";

const WeekStrip = ({ weekDays, selectedDate, onDateSelect }) => {
  return (
    <div className="week-strip">
      {["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"].map((day) => (
        <div key={day} className="week-day">{day}</div>
      ))}
      {weekDays.map((day) => (
        <div 
          key={day.toDateString()} 
          className={`date-number ${sameDay(day, selectedDate) ? 'selected' : ''}`}
          onClick={() => onDateSelect(day)}
        >
          {day.getDate()}
        </div>
      ))}
    </div>
  );
};

export default WeekStrip;